import React, { Component, Fragment } from 'react';
import isEmail from 'validator/lib/isEmail';
import { Button, Input, InputGroupAddon, InputGroup } from 'reactstrap';

import api from '../../lib/api';
import endpoint from '../../lib/endpoints';

export default class ActivationFailed extends Component {
  state = {
    email: '',
    hasSentMail: false,
    error: '',
  };

  handleEmailChange = e => this.setState({ email: e.target.value, error: '' });

  resendVerificationMail = async () => {
    const { email } = this.state;

    if (!isEmail(email)) {
      this.setState({ error: 'Invalid Email' });
      return;
    }

    try {
      const { status } = await api.postWithoutToken(endpoint.auth.resendVerificationMail, {
        email,
      });

      if (status === 200) this.setState({ hasSentMail: true });
    } catch (e) {
      this.setState({ error: e.response.data.message });
    }
  };

  render() {
    const { hasSentMail, error } = this.state;

    return (
      <div className="container">
        <div className="white-panel verifications">
          <h2>Activation Failed!</h2>
          <p className="mt-3">
            <strong>Your account activation link is no longer valid.</strong>
          </p>
          <p>This can happen if your activation link has expired.</p>
          {hasSentMail ? (
            <p>Please Check your email.</p>
          ) : (
            <Fragment>
              <div className="form-group verify-group">
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <span className="input-group-text">
                      <i className="icon icon-hg-email" />
                    </span>
                  </InputGroupAddon>
                  <Input onChange={this.handleEmailChange} />
                </InputGroup>
                {error && <div className="error">{error}</div>}
              </div>
              <div className="text-center">
                <Button color="yellow" onClick={this.resendVerificationMail}>
                  Resend
                </Button>
              </div>
            </Fragment>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Signup/ActivationFailed.jsx